import PropTypes from 'prop-types';
import { useWindowSize } from 'react-use';

import styles from './styles/styles.module.css';

function TariffCardItem({
  period,
  price,
  discount,
  oldPrice,
  badge,
  disabled,
  selected,
  onClick,
}) {
  const { width } = useWindowSize();
  const isMobile = width < 480;

  return (
    <button
      className={`
        ${styles.tariffCardContainer}
        ${disabled ? styles.tariffCardContainer_disabled : ''}
        ${selected ? styles.tariffCardContainer_selected : ''}
      `}
      onClick={onClick}
    >
      {badge ? <span className={styles.tariffCardBadge}>{badge}</span> : null}
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'end',
          paddingRight: '3px',
          marginTop: '3px',
        }}
      >
        {isMobile && discount ? (
          <span className={styles.tariffCardDiscountText}>{discount}%</span>
        ) : null}
      </div>
      <p className={styles.tariffCardTitle}>{period}</p>
      <p className={styles.tariffCardSubitle}>
        <span style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>{price} ₽</span>
        {!isMobile && discount ? (
          <span className={styles.tariffCardDiscountText}>{discount}%</span>
        ) : null}
      </p>
      {oldPrice ? (
        <span className={styles.tariffCardOldPriceText}>{oldPrice} ₽</span>
      ) : null}
    </button>
  );
}

export default TariffCardItem;

TariffCardItem.propTypes = {
  period: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  discount: PropTypes.string,
  oldPrice: PropTypes.string,
  badge: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};
